import { render } from "./fieldCheckbox.vue?vue&type=template&id=3644241e&scoped=true"
import script from "./fieldCheckbox.vue?vue&type=script&lang=js"
export * from "./fieldCheckbox.vue?vue&type=script&lang=js"

import "./fieldCheckbox.vue?vue&type=style&index=0&id=3644241e&scoped=true&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3644241e"]])

export default __exports__